import * as React from 'react';

import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';

import { Translate } from 'react-localize-redux';

import Button from '@components/actions/button';

import CreateAccountCtrl from '@webapp/controllers/registration/create-account';
import { SocialAuthCtrl } from '@webapp/controllers/registration/social-auth';
import styled from 'styled-components';

interface RegistrationStartPageProps {
  className?: string;
  hasInfo?: boolean;
  setHasInfo?: React.Dispatch<React.SetStateAction<boolean>>;
  setContactValue?: (email: string) => void;
}

export const RegistrationStartPage: React.FC<RegistrationStartPageProps> = ({
  className,
  hasInfo,
  setHasInfo,
  setContactValue,
}) => {
  const query = new URLSearchParams(useLocation().search);
  const redirectTo = query.get('redirectTo');

  const setLocalStorage = () => {
    if (redirectTo) {
      localStorage.setItem('redirectTo', redirectTo);
    }
  };

  return (
    <section className={className || ''}>
      <CreateAccountCtrl
        hasInfo={hasInfo}
        setHasInfo={setHasInfo}
        setContactValue={setContactValue}
      />
      {hasInfo && (
        <>
          <Separator />
          <SocialAuthCtrl label={<Translate id="AUTH.REGISTER.SOCIAL" />} />
          <Separator />
          <Link to="/login" onClick={setLocalStorage}>
            <Button className="mt-20" buttonType="secondary" fullWidth>
              <Translate id="REGISTER.BUTTON.EXISTING.ACCOUNT" />
            </Button>
          </Link>
        </>
      )}
    </section>
  );
};

export default RegistrationStartPage;

const Separator = styled.span`
  width: 100%;
  height: 1px;
  margin-top: 1px;
  display: block;
  margin-block: 20px;
  background-color: ${({ theme }) => theme.colors.headerBorder};
  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`;
